import { render } from "./realer.vue?vue&type=template&id=25fb2e62"
import script from "./realer.vue?vue&type=script&lang=js"
export * from "./realer.vue?vue&type=script&lang=js"

import "./realer.vue?vue&type=style&index=0&id=25fb2e62&lang=less"

import exportComponent from "D:\\Kaung\\KaungAdmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__